<template>
  <div>
    <div class="row mx-md-n2">
      <div class="col-sm-6 px-md-2">
        <b-form-group
          label="Title"
          :invalid-feedback="errors.title ? errors.title[0] : ''"
          :state="errors.title ? false : null"
        >
          <b-form-input
            name="title"
            type="text"
            trim
            v-model="resource.title"
            :state="errors.title ? false : null"
            :disabled="loading"
            required
          />
        </b-form-group>
      </div>

      <!-- Add Resource type dropdown here -->
      <div class="col-sm-6 px-md-2">
        <b-form-group
          label="Item Type"
          :invalid-feedback="errors.item_type ? errors.item_type[0] : ''"
          :state="errors.item_type ? false : null"
          v-if="!resource.uuid"
        >
          <b-form-select
            v-model="resource.item_type"
            :options="item_type_options"
            :disabled="resource.uuid != null && resource.uuid.length > 0"
            required
          ></b-form-select>
        </b-form-group>
        <div v-if="resource.uuid" class="d-flex align-items-end h-100">
          <b-btn class="mb-3 py-2" variant="primary" size="m" @click="viewResource()">
            View Resource
          </b-btn>
        </div>
      </div>
    </div>

    <div class="row mx-md-n2" v-if="resource.item_type && !resource.uuid">
      <div class="col-sm-6 px-md-2" v-if="usesUpload()">
        <b-form-group
          label="Select File"
          :invalid-feedback="errors.file ? errors.file[0] : ''"
          :state="errors.file ? false : null"
        >
          <b-form-file
            name="file"
            type="file"
            :accept="acceptableFileTypes()"
            placeholder="Choose a file..."
            @dragover.prevent
            @drop.prevent="addFile"
            drop-placeholder="Drag and Drop not supported"
            @change="resource.file = $event.target.files[0]; errors.file = null"
            :state="errors.file ? false : null"
            :disabled="loading || resource.uuid != null"
          />
        </b-form-group>
      </div>
      <div class="col-sm-6 px-md-2" v-else-if="!usesUpload()">
        <b-form-group
          label="URL"
          :invalid-feedback="errors.url ? errors.url[0] : ''"
          :state="errors.url ? false : null"
        >
          <b-form-input
            name="url"
            type="url"
            required
            trim
            autocomplete="username"
            v-model="resource.url"
            :state="errors.url ? false : null"
            :disabled="loading"
          />
        </b-form-group>

        <!-- Add link to view url here? -->
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <b-form-group label="Description">
          <b-form-textarea
            v-model="resource.description"
            placeholder="Describe your new educational resource"
            rows="2"
            max-rows="4"
            class="h-25"
            required
          />
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <b-form-group label="Select Skills">
          <b-form-checkbox-group
            name="skills"
            v-model="resource.skills"
            :options="skill_options"
            stacked
          ></b-form-checkbox-group>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EducationalItemInfoForm',
  props: {
    data: Object,
    errors: Object,
    loading: Boolean,
  },
  data() {
    return {
      resource: {},
      item_type_options: [
        { text: 'PDF', value: 'pdf' },
        { text: 'Power Point', value: 'ppt' },
        { text: 'MP4 Video', value: 'mp4' },
        { text: 'YouTube Link', value: 'youtube' },
        { text: 'Google Drive Video Link', value: 'gdrive' },
        { text: 'URL', value: 'url' },
        { text: 'Excel', value: 'xls'}
      ],
      skill_options: [
        { text: 'Finance - Accounting, Tax, Finance', value: '1' },
        { text: 'Legal', value: '2' },
        { text: 'HR', value: '3' },
        { text: 'Strategy - Strategy, Planning, Capital', value: '4' },
        {
          text: 'Ops - Operations, Product Development, Manufacturing',
          value: '5',
        },
        { text: 'Technology', value: '6' },
        {
          text:
            'Mktg/Sales - Marketing, Public Relations, Sales, Customer Relations',
          value: '7',
        },
        { text: 'Buy/Sell - Buying and Selling Business', value: '8' },
        { text: 'Franchising', value: '9' },
        { text: 'Intl - International Sales & Procurement', value: '10' },
        { text: 'Govt - Government Regulations & Contracting', value: '11' },
      ],
    }
  },
  mounted() {
    this.resource = Object.assign({}, this.data)

    this.$skillsService.getSkillsAsValues(false)
      .then((skills) => {
        this.skill_options = skills
      })
  },
  methods: {
    usesUpload() {
      const uploadTypes = ['pdf', 'ppt', 'mp4', 'xls']
      return uploadTypes.indexOf(this.resource.item_type) >= 0
    },
    acceptableFileTypes() {
      // application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/pdf,video/mp4
      if (!this.resource.item_type) {
        return
      }
      switch (this.resource.item_type) {
        case 'pdf':
          return 'application/pdf'
        case 'ppt':
          return 'application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation'
        case 'xls':
          return 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        case 'mp4':
          return 'video/mp4'
        default:
          return ''
      }
    },
    viewResource() {
      window.open(this.resource.url, '_blank')
    },
  },
}
</script>
